for (const timeline of document.querySelectorAll(".timeline")) {
  const viewport = timeline.querySelector(".timeline__items");
  if (viewport == null) throw new Error("Timeline with no viewport");

  const items: NodeListOf<HTMLElement> =
    viewport.querySelectorAll(".timeline__item");

  const container = timeline.querySelector<HTMLElement>(".timeline__controls");
  if (container == null) throw new Error("Timeline with no controls container");
  const buttonPrev = timeline.querySelector<HTMLButtonElement>(
    ".timeline__control--prev"
  );
  if (buttonPrev == null) throw new Error("Timeline with no prev button");
  const buttonNext = timeline.querySelector<HTMLButtonElement>(
    ".timeline__control--next"
  );
  if (buttonNext == null) throw new Error("Timeline with no next button");

  // Watch for scroll and resize events,
  // and enable/disable controls as appropriate
  const updateControls = (): void => {
    buttonPrev.disabled = viewport.scrollLeft <= 0;
    buttonNext.disabled =
      viewport.scrollLeft >= viewport.scrollWidth - viewport.clientWidth;
  };
  window.addEventListener("resize", updateControls);
  viewport.addEventListener("scroll", updateControls);
  updateControls();

  // Handle clicks on prev/next buttons
  const scroll = (multiplier: number): void => {
    // We don't scroll unless there are at least two items
    if (items.length < 2) return;

    // How big is a container?
    const containerStyle = window.getComputedStyle(container);
    const containerWidth =
      container.getBoundingClientRect().width -
      parseInt(containerStyle.getPropertyValue("padding-left")) -
      parseInt(containerStyle.getPropertyValue("padding-right"));

    // How far from one item to the next?
    const itemOffset = items[1].offsetLeft - items[0].offsetLeft;

    // Decide how far to scroll
    const scrollDelta =
      itemOffset * Math.max(1, Math.floor(containerWidth / itemOffset) - 1);

    // Scroll the viewport
    viewport.scrollBy({
      left: scrollDelta * multiplier,
      behavior: "smooth",
    });
  };
  buttonPrev.addEventListener("click", () => scroll(-1));
  buttonNext.addEventListener("click", () => scroll(1));
}
